/* ==========================
★★フェードアニメ★★
========================== */
document.addEventListener('DOMContentLoaded', function () {
  function fadeInOnScroll(inClass, doneClass, autoFirst = false, stagger = 0) {
    const items = document.querySelectorAll(inClass);
    if (autoFirst && items.length > 0) {
      items[0].classList.add(doneClass);
    }
    function onScroll() {
      const winH = window.innerHeight;
      let visibleIndex = 0;
      items.forEach((item, index) => {
        if (autoFirst && index === 0) return;
        if (item.classList.contains(doneClass)) return;
        const rect = item.getBoundingClientRect();
        if (rect.top < winH * 0.8) {
          if (stagger > 0) {
            item.style.animationDelay = `${visibleIndex * stagger}s`;
            visibleIndex++;
          }
          item.classList.add(doneClass);
        }
      });
    }
    window.addEventListener('scroll', onScroll);
    onScroll();
  }
  fadeInOnScroll('.fd-in', 'fd-done', true, 0.05);
  fadeInOnScroll('.sc-in', 'sc-done', false, 0.05);
});

/* ==========================
★★回転★★
========================== */
document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.scroll-rotate');
  if (!el) return;
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect();
      const winH = window.innerHeight;
      const progress = 1 - (rect.top + rect.height / 2) / winH;
      const clamped = Math.max(0, Math.min(1, progress));
      const rotate = clamped * 480;// 回転角度（大きいと早い）
      el.style.transform = `rotate(${rotate}deg)`;
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll);
  onScroll();
});


/* ==========================
パララックス（したのやつ）
data-stick は freeze_move 用
data-trigger は 画面内での発火位置調整
========================== */
document.addEventListener("DOMContentLoaded", function () {

  const elements = document.querySelectorAll(".freeze_move");
  if (!elements.length) return;

  let instances = [];

  function init() {
    instances = [];
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const winW = window.innerWidth;
    const winH = window.innerHeight;

    elements.forEach(el => {

      // スペーサー生成
      const spacer = document.createElement("div");
      spacer.style.height = "0px";
      spacer.style.pointerEvents = "none";
      el.parentNode.insertBefore(spacer, el.nextSibling);

      instances.push({
        el,
        spacer,
        frozen: false,
        top: 0,
        height: 0,
        stickRatio: el.dataset.stick !== undefined
          ? parseFloat(el.dataset.stick)
          : 0.5,
        triggerRatio: el.dataset.trigger !== undefined
          ? parseFloat(el.dataset.trigger)
          : 1,
      });
    });

    calculatePositions();
    update();

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", calculatePositions);
  }

  function calculatePositions() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    instances.forEach(obj => {
      if (obj.frozen) return;

      const rect = obj.el.getBoundingClientRect();
      obj.top = rect.top + scrollTop;
      obj.height = obj.el.offsetHeight;
    });
  }

  function update() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const winH = window.innerHeight;

    instances.forEach(obj => {
      const { el, spacer } = obj;
      const triggerLine = winH * obj.triggerRatio;

      /* ===== 固定開始 ===== */
      if (!obj.frozen && scrollY + triggerLine >= obj.top + obj.height) {
        obj.frozen = true;

        spacer.style.height = obj.height + "px";

        const rect = el.getBoundingClientRect();
        el.style.position = "fixed";
        el.style.left = rect.left + "px";
        el.style.width = rect.width + "px";

        el.style.top = (triggerLine - obj.height) + "px";

        el.classList.add("freeze-active");
      }

      /* ===== 固定解除 ===== */
      if (obj.frozen && scrollY + triggerLine < obj.top + obj.height) {
        obj.frozen = false;

        el.style.position = "";
        el.style.top = "";
        el.style.left = "";
        el.style.width = "";

        el.classList.remove("freeze-active");
        spacer.style.height = "0px";

        const rect = el.getBoundingClientRect();
        obj.top = rect.top + scrollY;
        obj.height = el.offsetHeight;
      }
    });
  }

  function handleResize() {
    calculatePositions();
    update();
  }

  window.addEventListener("load", init);
});

/* ==========================
★★パララックスTOP★★
========================== */
document.addEventListener("DOMContentLoaded", function () {

  const elements = document.querySelectorAll(".freeze");
  if (!elements.length) return;

  const instances = [];
  let ticking = false;

  function init() {

    elements.forEach(el => {

      const stickRatio = el.dataset.stick
        ? parseFloat(el.dataset.stick)
        : 0.8;

      instances.push({
        el,
        stickRatio,
        topStart: 0,
        height: 0,
        triggerStart: 0,
        maxOffset: 0
      });

      el.style.willChange = "transform";
      el.style.transform = "translate3d(0,0,0)";
      el.style.backfaceVisibility = "hidden";
    });

    waitImages().then(() => {
      calculatePositions();
      update(); // 初期描画
      window.addEventListener("resize", handleResize);
      window.addEventListener("scroll", onScroll, { passive: true });
    });
  }

  function waitImages() {
    const imgs = document.querySelectorAll(".freeze img");
    const promises = Array.from(imgs).map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(resolve => {
        img.addEventListener("load", resolve);
        img.addEventListener("error", resolve);
      });
    });
    return Promise.all(promises);
  }

  function calculatePositions() {

    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const winH = window.innerHeight;

    instances.forEach(obj => {

      const rect = obj.el.getBoundingClientRect();

      obj.topStart = rect.top + scrollY;
      obj.height = obj.el.offsetHeight;

      const rawTrigger =
        obj.topStart + obj.height - winH * obj.stickRatio;

      obj.triggerStart = Math.max(obj.topStart, rawTrigger);

      obj.maxOffset = Math.max(
        0,
        obj.height - winH * (1 - obj.stickRatio)
      );
    });
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {

    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    instances.forEach(obj => {

      let offset = scrollY - obj.triggerStart;

      if (offset <= 0) {
        obj.el.style.transform = "translate3d(0,0,0)";
        return;
      }

      offset = Math.min(offset, obj.maxOffset);

      // 小数による揺れ防止
      offset = Math.round(offset);

      obj.el.style.transform = `translate3d(0,${offset}px,0)`;
    });

    ticking = false;
  }

  function handleResize() {
    calculatePositions();
    update();
  }

  init();
});

/* ==========================
★★スライダー★★
========================== */
(() => {
  const slider = document.getElementById('slider');
  if (!slider) return;

  const wrap = slider.querySelector('.slides');
  const prevBtn = slider.querySelector('.slide-prev');
  const nextBtn = slider.querySelector('.slide-next');
  const pagination = slider.querySelector('.slide-pagination');

  if (!wrap) return;

  const originalSlides = Array.from(wrap.querySelectorAll('.slide'));
  if (originalSlides.length === 0) return;

  if (originalSlides.length === 1) {
    loadSlide(originalSlides[0]);
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    if (pagination) pagination.style.display = 'none';
    return;
  }

  const AUTOPLAY_DELAY = 5000;
  const TRANSITION_TIME = 600;

  let index = 1;
  let timer = null;
  let isMoving = false;
  let startX = 0;
let startTime = 0;
let lastX     = 0;
let velocity  = 0;    

  function loadSlide(slide) {
    if (!slide || slide.dataset.loaded) return;

    slide.querySelectorAll('source').forEach(source => {
      if (source.dataset.srcset) {
        source.srcset = source.dataset.srcset;
      }
    });

    const img = slide.querySelector('img');
    if (img && img.dataset.src) {
      img.src = img.dataset.src;
    }

    slide.dataset.loaded = "true";
  }

  const firstClone = originalSlides[0].cloneNode(true);
  const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);

  wrap.appendChild(firstClone);
  wrap.insertBefore(lastClone, originalSlides[0]);

  const allSlides = Array.from(wrap.querySelectorAll('.slide'));

  wrap.style.display = "flex";
  wrap.style.transition = `transform ${TRANSITION_TIME}ms ease`;
  wrap.style.willChange = "transform";

  allSlides.forEach(slide => {
    slide.style.flex = "0 0 100%";
  });

  wrap.style.transform = `translateX(-${index * 100}%)`;

  loadSlide(allSlides[index]);
  loadSlide(allSlides[index + 1]);
  loadSlide(allSlides[index - 1]);

  if (pagination) {
    originalSlides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.addEventListener('click', () => goTo(i + 1));
      pagination.appendChild(btn);
    });
  }

  function updatePagination() {
    if (!pagination) return;
    const realIndex = (index - 1 + originalSlides.length) % originalSlides.length;
    Array.from(pagination.children).forEach((btn, i) => {
      btn.classList.toggle('active', i === realIndex);
    });
  }

  updatePagination();

  function goTo(newIndex) {
    if (isMoving) return;
    isMoving = true;

    index = newIndex;

    loadSlide(allSlides[index]);
    loadSlide(allSlides[index + 1]);
    loadSlide(allSlides[index - 1]);

    wrap.style.transition = `transform ${TRANSITION_TIME}ms ease`;
    wrap.style.transform = `translateX(-${index * 100}%)`;

    updatePagination();
  }

  function next() {
    goTo(index + 1);
  }

  function prev() {
    goTo(index - 1);
  }

  wrap.addEventListener('transitionend', () => {
    if (index === allSlides.length - 1) {
      wrap.style.transition = "none";
      index = 1;
      wrap.style.transform = `translateX(-${index * 100}%)`;
    }

    if (index === 0) {
      wrap.style.transition = "none";
      index = originalSlides.length;
      wrap.style.transform = `translateX(-${index * 100}%)`;
    }

    isMoving = false;
    updatePagination();
  });

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(next, AUTOPLAY_DELAY);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  startAutoplay();

  slider.addEventListener("mouseenter", stopAutoplay);
  slider.addEventListener("mouseleave", startAutoplay);

  nextBtn?.addEventListener("click", next);
  prevBtn?.addEventListener("click", prev);

  slider.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener("touchend", e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
    }
  });

  slider.addEventListener("mousedown", e => {
    startX = e.clientX;
  });

  slider.addEventListener("mouseup", e => {
    const diff = startX - e.clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
    }
  });

})();


/* ==========================
★★漫画pc★★
========================== */ 
document.addEventListener("DOMContentLoaded", function () {

  const mangaBoxes = document.querySelectorAll(".manga_box");

  mangaBoxes.forEach(function (box) {

    const track = box.querySelector(".pc_manga_track");
    const pages = Array.from(box.querySelectorAll(".pc_manga_page"));
    const nextBtn = box.querySelector(".pc_manga_next");
    const prevBtn = box.querySelector(".pc_manga_prev");
    const counter = box.querySelector(".pc_manga_counter");

    if (!track || !pages.length || !nextBtn || !prevBtn) return;

    pages.reverse().forEach(page => {
      track.appendChild(page);
    });

    let current = pages.length - 1; 
    const total = pages.length;
    const autoInterval = 6000;
    let autoPlay = null;
    let autoEnabled = true;
    let inView = false;

    function update() {
      track.style.transition = "transform 0.6s ease";
      track.style.transform = `translateX(-${current * 100}%)`;

      nextBtn.style.display = current === 0 ? "none" : "inline-block";
      prevBtn.style.display = current === total - 1 ? "none" : "inline-block";

      if (counter) {
        counter.textContent = (total - current) + " / " + total;
      }
    }

    function next() {
      if (current > 0) {
        current--;
        update();
      }
    }

    function prev() {
      if (current < total - 1) {
        current++;
        update();
      }
    }

    function resetToFirst() {
      current = total - 1;
      update();
    }

    function startAuto() {
      if (!autoEnabled || autoPlay || !inView) return;

      autoPlay = setInterval(() => {
        if (current > 0) {
          next();
        }
      }, autoInterval);
    }

    function stopAuto() {
      if (autoPlay) {
        clearInterval(autoPlay);
        autoPlay = null;
      }
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          inView = true;
          startAuto();
        } else {
          inView = false;
          stopAuto();
        }
      });
    }, { threshold: 0.4 });

    observer.observe(box);

    nextBtn.addEventListener("click", function () {
      autoEnabled = false;
      stopAuto();
      next();
    });

    prevBtn.addEventListener("click", function () {
      autoEnabled = false;
      stopAuto();
      prev();
    });

    document.querySelectorAll(".pc_manga_tab").forEach(function(btn){

      btn.addEventListener("click", function(e){
        e.preventDefault();

        const targetTab = this.dataset.tab;

        document.querySelectorAll(".pc_manga_tab").forEach(b=>{
          b.classList.remove("pc_manga_active");
        });
        this.classList.add("pc_manga_active");

        document.querySelectorAll(".manga_box").forEach(b=>{
          if (b.dataset.tab === targetTab) {
            b.classList.add("pc_manga_active");

            if (b === box) {
              resetToFirst();
              autoEnabled = true;
              startAuto();
            }
          } else {
            b.classList.remove("pc_manga_active");
            if (b === box) {
              stopAuto();
            }
          }
        });
      });
    });
    update();
  });
});


/* ==========================
漫画SP
========================== */  
document.addEventListener("DOMContentLoaded", function () {

const comics = {
comic1: [
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move02.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move03.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move04.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move05.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move06.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move07.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move08.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/move09.jpg"
],
comic2: [
"https://zzu23b-pd.myshopify.com/cdn/shop/files/relax02.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/relax03.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/relax04.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/relax05.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/relax06.jpg",
"https://zzu23b-pd.myshopify.com/cdn/shop/files/relax07.jpg"
]
};

let images = [];
let index = 0;
let isAnimating = false;

let startX = 0;
let startY = 0;
let isSwipe = false;

const modal = document.getElementById("manga_modal");
const track = document.getElementById("manga_sliderTrack");
const page = document.getElementById("manga_page");
const nextBtn = document.getElementById("manga_nextBtn"); // 左＝次
const prevBtn = document.getElementById("manga_prevBtn"); // 右＝前
const closeBtn = document.getElementById("manga_closeBtn");

if (!modal || !track) return;


/* 画像プリロード */
function preloadImages(arr) {
return Promise.all(
arr.map(src => {
return new Promise(resolve => {
const img = new Image();
img.src = src;
img.onload = resolve;
img.onerror = resolve;
});
})
);
}


/* スライダー構築 */
function buildSlider() {

track.innerHTML = "";

/* 配列を逆にする（超重要） */
images = images.slice().reverse();

images.forEach(src => {
const img = document.createElement("img");
img.src = src;
track.appendChild(img);
});

/* 最後から開始（1ページ目） */
index = images.length - 1;

requestAnimationFrame(() => update(true));
}


/* 描画更新 */
function update(force = false) {

if (isAnimating && !force) return;

const width = modal.querySelector(".manga_slider").clientWidth;

/* index減ると左に進む（漫画） */
track.style.transition = "none";
track.style.transform = `translateX(-${index * width}px)`;

requestAnimationFrame(() => {
track.style.transition = "transform .4s ease";
});

/* ページ表示（元の順番に戻す） */
page.textContent = `${images.length - index} / ${images.length}`;

/* ボタン制御 */
nextBtn.style.display = index === 0 ? "none" : "block";          // 次（左）
prevBtn.style.display = index === images.length - 1 ? "none" : "block"; // 前（右）
}


/* ページ移動 */
function goTo(newIndex) {

if (isAnimating) return;
if (newIndex < 0 || newIndex >= images.length) return;

isAnimating = true;
index = newIndex;

const width = modal.querySelector(".manga_slider").clientWidth;

track.style.transform = `translateX(-${index * width}px)`;

setTimeout(() => {
isAnimating = false;
update(true);
}, 400);
}


/* OPEN */
document.querySelectorAll(".openComic").forEach(link => {

link.addEventListener("click", async function (e) {

e.preventDefault();
e.stopPropagation();

const key = this.dataset.comic;
if (!comics[key]) return;

images = comics[key];

modal.style.display = "flex";

/* 描画待ち */
await new Promise(r => requestAnimationFrame(r));

/* 画像ロード待ち */
await preloadImages(images);

buildSlider();

});
});


/* CLOSE */
closeBtn.onclick = () => modal.style.display = "none";

modal.onclick = e => {
if (e.target === modal) modal.style.display = "none";
};


/* ボタン（漫画仕様） */
nextBtn.onclick = () => goTo(index - 1); // 次
prevBtn.onclick = () => goTo(index + 1); // 前


/* スワイプ（漫画仕様） */
track.addEventListener("touchstart", e => {
startX = e.touches[0].clientX;
startY = e.touches[0].clientY;
isSwipe = false;
}, { passive: true });

track.addEventListener("touchmove", e => {

const dx = e.touches[0].clientX - startX;
const dy = e.touches[0].clientY - startY;

if (Math.abs(dx) > Math.abs(dy)) {
isSwipe = true;
e.preventDefault();
}

}, { passive: false });

track.addEventListener("touchend", e => {

if (!isSwipe) return;

const diff = e.changedTouches[0].clientX - startX;
const width = modal.querySelector(".manga_slider").clientWidth;
const threshold = width * 0.15;

/* 漫画仕様 */
if (diff > threshold) {
goTo(index - 1); // 右スワイプ → 次
}
else if (diff < -threshold) {
goTo(index + 1); // 左スワイプ → 前
}

});


/* リサイズ */
function fixSlider() {

if (modal.style.display !== "flex") return;

const width = modal.querySelector(".manga_slider").clientWidth;

track.style.transition = "none";
track.style.transform = `translateX(-${index * width}px)`;

requestAnimationFrame(() => {
track.style.transition = "transform .4s ease";
});

}

window.addEventListener("resize", fixSlider);
window.addEventListener("orientationchange", fixSlider);

});


/* =====================================================
★★商品一覧カルーセル（PC慣性 / SPネイティブ+active対応）
===================================================== */
$(function(){

const SP_BREAKPOINT = 810;
const SCROLL_POWER  = 1.2;
const FRICTION      = 0.90;

const $container = $('.carousel-container');
const $track     = $('.carousel-track');
const $slides    = $('.carousel-slide');

const $bg1 = $('.bg1');
const $bg2 = $('.bg2');

let current = 0;
let velocity = 0;
let animationFrame = null;

let slideW = 0;
let totalWidth = 0;

let currentBg = "";
let activeBg = 1;

/* =============================
   ユーティリティ
============================= */

function isSP(){
  return window.innerWidth <= SP_BREAKPOINT;
}

function calculateSizes(){
  slideW = $slides.outerWidth(true);
  totalWidth = slideW * $slides.length;
}

function setTransform(value){
  $track.css('transform', `translate3d(${value}px,0,0)`);
}

/* =============================
   中央index取得（共通）
============================= */

function getCenterIndex(){

  const containerRect = $container[0].getBoundingClientRect();
  const containerCenter = containerRect.left + containerRect.width / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  $slides.each(function(index){

    const rect = this.getBoundingClientRect();
    const slideCenter = rect.left + rect.width / 2;
    const distance = Math.abs(containerCenter - slideCenter);

    if(distance < minDistance){
      minDistance = distance;
      closestIndex = index;
    }

  });

  return closestIndex;
}

/* =============================
   active付与（SPでも動かす）
============================= */

function updateActive(){

  const index = getCenterIndex();

  $slides.removeClass('active');
  $slides.eq(index).addClass('active');
}

/* =============================
   背景更新（SPでも動かす）
============================= */
function updateBackground(initial = false){

  const index = getCenterIndex();
  const newBg = $slides.eq(index).data('bg');

  if(!newBg) return;
  if(!initial && newBg === currentBg) return;

  currentBg = newBg;

  const $next = activeBg === 1 ? $bg2 : $bg1;
  const $prev = activeBg === 1 ? $bg1 : $bg2;

  const img = new Image();
  img.src = newBg;

  img.onload = function(){

    $next.find('img').attr('src', newBg);

    requestAnimationFrame(()=>{
      $next.addClass('is-show');
      $prev.removeClass('is-show');
    });

    activeBg = activeBg === 1 ? 2 : 1;
  };
}
/* =============================
   スケール（PCのみ）
============================= */

function updateScale(){

  if(isSP()) return;

  const containerRect = $container[0].getBoundingClientRect();
  const containerCenter = containerRect.left + containerRect.width / 2;

  $slides.each(function(){

    const rect = this.getBoundingClientRect();
    const slideCenter = rect.left + rect.width / 2;
    const distance = Math.abs(containerCenter - slideCenter);

    const maxDistance = containerRect.width / 2;

    let scale = 1 - (distance / maxDistance) * 0.15;
    if(scale < 0.85) scale = 0.85;

    this.style.transform = `scale(${scale})`;
  });
}

/* =============================
   慣性（PCのみ）
============================= */

function startInertia(){

  if(isSP()) return;
  if(animationFrame) return;

  function animate(){

    velocity *= FRICTION;
    current += velocity;

    const containerWidth = $container.width();
    const centerOffset = (containerWidth - slideW) / 2;

    const max = centerOffset;
    const min = -(totalWidth - slideW) + centerOffset;

    if(current > max){
      current = max;
      velocity = 0;
    }

    if(current < min){
      current = min;
      velocity = 0;
    }

    setTransform(current);
    updateScale();
    updateBackground();
    updateActive();

    if(Math.abs(velocity) > 0.2){
      animationFrame = requestAnimationFrame(animate);
    }else{
      velocity = 0;
      animationFrame = null;
    }
  }

  animationFrame = requestAnimationFrame(animate);
}

/* =============================
   PCホイール
============================= */
$track[0].addEventListener('wheel', function(e){

  if(isSP()) return;

  const containerWidth = $container.width();
  const centerOffset = (containerWidth - slideW) / 2;

  const max = centerOffset;
  const min = -(totalWidth - slideW) + centerOffset;

  const scrollingDown = e.deltaY > 0;
  const scrollingUp   = e.deltaY < 0;

  const atStart = current >= max;
  const atEnd   = current <= min;

  if((atEnd && scrollingDown) || (atStart && scrollingUp)){
    return;
  }

  e.preventDefault();

  velocity = -e.deltaY * SCROLL_POWER;
  startInertia();

},{ passive:false });

/* =============================
   SPスクロール検知（重要）
============================= */

let scrollTimer;

$container.on('scroll', function(){

  if(!isSP()) return;

  updateActive();
  updateBackground();

  /* スクロール停止検知 */
  clearTimeout(scrollTimer);

  scrollTimer = setTimeout(function(){

    const container = $container[0];

    const maxScroll = container.scrollWidth - container.clientWidth;

    /* 最後までスクロールしていたら */
    if(container.scrollLeft >= maxScroll - 2){

      const lastIndex = $slides.length - 1;
      const newBg = $slides.eq(lastIndex).data('bg');

      if(newBg && newBg !== currentBg){

        currentBg = newBg;

        const $next = activeBg === 1 ? $bg2 : $bg1;
        const $prev = activeBg === 1 ? $bg1 : $bg2;

        const img = new Image();
        img.src = newBg;

        img.onload = function(){

          $next.find('img').attr('src', newBg);

          requestAnimationFrame(()=>{
            $next.addClass('is-show');
            $prev.removeClass('is-show');
          });

          activeBg = activeBg === 1 ? 2 : 1;
        };
      }

    }

  },120); // スクロール停止判定

});

/* =============================
   初期セット
============================= */

function setInitialPosition(){

  calculateSizes();

  if(!isSP()){

    const containerWidth = $container.width();
    current = (containerWidth - slideW) / 2;
    setTransform(current);

    $container.css({ overflow: 'hidden' });

  }else{

    velocity = 0;
    animationFrame = null;

    $track.css({ transform: 'none' });
    $slides.css({ transform: 'none' });

    $container.css({
      overflowX: 'auto',
      overflowY: 'hidden',
      WebkitOverflowScrolling: 'touch'
    });
  }

  updateActive();
  updateBackground(true);
  updateScale();
}

setInitialPosition();

$(window).on('resize', setInitialPosition);

});